// src/components/ThemeProvider.js
import React from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Create a bluish-white theme for language learning
const theme = createTheme({
  palette: {
    primary: {
      main: '#3f51b5', // Blue primary color
      light: '#757de8',
      dark: '#2c387e',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#4dabf5', // Lighter blue for accents
      light: '#80d8ff',
      dark: '#2286c3',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#f5f7fa',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2d3748', // Dark text for readability
      secondary: '#4a5568',
    },
    error: {
      main: '#f44336',
    },
    success: {
      main: '#4caf50', 
    },
    info: {
      main: '#2196f3',
    }
  },
  typography: {
    fontFamily: [
      'Inter',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: '1.1rem',
    },
    subtitle2: {
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px 0 rgba(0,0,0,0.05)',
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 4px 0 rgba(0,0,0,0.05)',
        }
      }
    }
  },
});

// Theme provider component
const ThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;